import React, { useCallback, useState } from 'react';
import { Typography } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { toast } from 'react-toastify';
import useStyles from './AlterarComercialProcesso.style';
import {
  TITULO_PAGINA,
  SUBTITULO_PAGINA,
  MAX_LENGTH_NUM_PROCESSO,
  MINIMO_PALAVRAS_JUSTIFICATIVA,
  MAX_COUNTER_JUSTIFICATIVA,
  LABEL_NUMERO_PROCESSO,
  LABEL_CODIGO_COMERCIAL,
  LABEL_NOME_COMERCIAL,
  LABEL_NOVO_CODIGO_COMERCIAL,
  LABEL_CONSULTAR,
  LABEL_JUSTIFICATIVA,
  LABEL_ALTERAR,
  STATUS_USUARIO_ATIVO,
  MENSAGEM_ERRO_BUSCA_PROCESSO,
  MENSAGEM_ERRO_BUSCA_COMERCIAL_NOVO,
  MENSAGEM_RESTRICAO_COMERCIAL_NOVO,
  MENSAGEM_SUCESSO_ALTERACAO,
  MENSAGEM_ERRO_ALTERACAO,
  MENSAGEM_CONFIRMACAO_ALTERACAO,
  MENSAGEM_ERRO_HISTORICO_AUTOMATICO,
} from './alterarComercialProcesso.constants';
import LoadingUI from '../../../components/UI/Loading/LoadingUI';
import WrapperSubTitleForm from '../../../components/UI/WrapperSubTitleForm/WrapperSubTitleForm';
import Grid24 from '../../../components/UI/Grid24/Grid24';
import { ButtonUI, TextareaField } from '../../../components';
import NumberInput from '../../../components/UI/Field/Number/NumberInput';
import InputField from '../../../components/UI/Field/Input/InputField';
import OptionDialogNew from '../../../components/UI/Dialogs/OptionDialog/OptionDialogNew';
import { SearchButton } from '../../../components/SearchButton/SeachButton';
import { getExceptionMessage } from '../../../helpers';
import {
  findComercialAtualByNumProcesso,
  updateComercialDoProcesso,
} from '../../../services/core/manutencao/manutencao.service';
import {
  getUsuarioCompletoPeloId,
  buscarIdTipoUsuarioComercial,
} from '../../../services/core/usuario/usuario.services';
import { inserirNovoHistorico } from '../../../services/core/processos/processosService';
import { tiposHistoricos } from '../../../types/tiposHistoricoTypes';

function possuiMinimoPalavras(texto, minimo) {
  return texto.trim().split(/\s+/).filter(Boolean).length >= minimo;
}

export default function AlterarComercialProcesso() {
  const style = useStyles();

  const [loading, setLoading] = useState(false);
  const [numProcesso, setNumProcesso] = useState('');
  const [comercialAtual, setComercialAtual] = useState(null);

  const [codigoNovoComercial, setCodigoNovoComercial] = useState('');
  const [comercialNovo, setComercialNovo] = useState(null);
  const [loadingComercialNovo, setLoadingComercialNovo] = useState(false);

  const [justificativa, setJustificativa] = useState('');

  const [confirmacaoAberta, setConfirmacaoAberta] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const buscarProcesso = useCallback((numero) => {
    setLoading(true);
    return findComercialAtualByNumProcesso(numero).then((response) => {
      if (!response?.data?.idUsuarioComercial) {
        throw new Error('Resposta da busca de processo fora do contrato esperado');
      }
      setComercialAtual(response.data);
      setCodigoNovoComercial('');
      setComercialNovo(null);
      setJustificativa('');
    }).catch((exception) => {
      setComercialAtual(null);
      toast.error(getExceptionMessage(exception) || MENSAGEM_ERRO_BUSCA_PROCESSO);
    }).finally(() => {
      setLoading(false);
    });
  }, []);

  const handleSubmitSearchForm = useCallback((e) => {
    e.preventDefault();
    buscarProcesso(numProcesso);
  }, [buscarProcesso, numProcesso]);

  const handleChangeNumProcesso = useCallback((e) => {
    const { value } = e.target;
    setNumProcesso(value);
  }, []);

  const handleConsultarNovoComercial = useCallback(() => {
    setLoadingComercialNovo(true);
    Promise.all([
      getUsuarioCompletoPeloId(codigoNovoComercial.trim()),
      buscarIdTipoUsuarioComercial(),
    ]).then(([usuarioResponse, tipoComercialResponse]) => {
      if (!usuarioResponse?.data || tipoComercialResponse?.data == null) {
        throw new Error('Resposta da consulta de usuário comercial fora do contrato esperado');
      }

      const usuario = usuarioResponse.data;
      const idTipoUsuarioComercial = tipoComercialResponse.data;
      const ativo = usuario?.statusUsuario === STATUS_USUARIO_ATIVO;
      const possuiPerfilComercial = usuario?.idTipoUsuario === idTipoUsuarioComercial;

      if (!ativo || !possuiPerfilComercial) {
        // Validação só de UX — o backend deve revalidar status e perfil comercial no PUT (Etapa 6).
        setComercialNovo(null);
        toast.warn(MENSAGEM_RESTRICAO_COMERCIAL_NOVO);
        return;
      }

      setComercialNovo(usuario);
    }).catch((exception) => {
      setComercialNovo(null);
      toast.warn(getExceptionMessage(exception) || MENSAGEM_ERRO_BUSCA_COMERCIAL_NOVO);
    }).finally(() => {
      setLoadingComercialNovo(false);
    });
  }, [codigoNovoComercial]);

  const handleChangeCodigoNovoComercial = useCallback((e) => {
    const { value } = e.target;
    setCodigoNovoComercial(value);
    setComercialNovo(null);
  }, []);

  const handleChangeJustificativa = useCallback((e) => {
    setJustificativa(e.target.value);
  }, []);

  const abrirConfirmacao = useCallback(() => {
    setConfirmacaoAberta(true);
  }, []);

  const fecharConfirmacao = useCallback(() => {
    setConfirmacaoAberta(false);
  }, []);

  const confirmarAlteracao = useCallback(() => {
    const codigoAnterior = comercialAtual?.idUsuarioComercial;
    const idProcesso = numProcesso;
    const codigoNovo = codigoNovoComercial.trim();
    const motivo = justificativa.trim();

    setLoadingSubmit(true);
    updateComercialDoProcesso(numProcesso, codigoNovo, motivo)
      .then(() => {
        toast.success(MENSAGEM_SUCESSO_ALTERACAO);
        const texto = `Alterado o usuário comercial do processo de ${codigoAnterior} para ${codigoNovo}, motivo: ${motivo}`;
        inserirNovoHistorico(idProcesso, tiposHistoricos.COMENTARIO_AUTOMATIO.key, texto).catch(() => {
          toast.warn(MENSAGEM_ERRO_HISTORICO_AUTOMATICO);
        });
        return buscarProcesso(numProcesso);
      })
      .catch((exception) => {
        toast.error(getExceptionMessage(exception) || MENSAGEM_ERRO_ALTERACAO);
      })
      .finally(() => {
        setLoadingSubmit(false);
        setConfirmacaoAberta(false);
      });
  }, [comercialAtual, numProcesso, codigoNovoComercial, justificativa, buscarProcesso]);

  const justificativaValida = possuiMinimoPalavras(justificativa, MINIMO_PALAVRAS_JUSTIFICATIVA);
  const habilitarBotaoAlterar = Boolean(comercialNovo) && justificativaValida;

  return (
    <WrapperSubTitleForm title={TITULO_PAGINA} className={style.pageRoot}>
      <LoadingUI show={loading || loadingComercialNovo || loadingSubmit} />
      <Typography>{SUBTITULO_PAGINA}</Typography>

      <form onSubmit={handleSubmitSearchForm}>
        <Grid24 container isFormContainer spacing="1" className={style.formSection}>
          <Grid24 xs={24} sm={6}>
            <NumberInput
              isForm
              fullWidth
              numberType="integer"
              name="numProcesso"
              label={LABEL_NUMERO_PROCESSO}
              value={numProcesso}
              onChange={handleChangeNumProcesso}
              maxLength={MAX_LENGTH_NUM_PROCESSO}
              acceptEmptyValue
            />
          </Grid24>
          <Grid24 xs={24} sm={2}>
            <SearchButton
              className={style.searchButtonCircular}
              type="submit"
              disabled={numProcesso.trim() === ''}
            >
              <SearchIcon />
            </SearchButton>
          </Grid24>
        </Grid24>
      </form>

      {comercialAtual && (
        <Grid24 container isFormContainer spacing="1" className={style.formSection}>
          <Grid24 xs={24} sm={4}>
            <InputField
              disabled
              isForm
              fullWidth
              label={LABEL_CODIGO_COMERCIAL}
              value={comercialAtual.idUsuarioComercial}
            />
          </Grid24>
          <Grid24 xs={24} sm={10}>
            <InputField
              disabled
              isForm
              fullWidth
              label={LABEL_NOME_COMERCIAL}
              value={comercialAtual.nomeComercial}
            />
          </Grid24>
        </Grid24>
      )}

      {comercialAtual && (
        <Grid24 container isFormContainer spacing="1" className={style.formSection}>
          <Grid24 xs={24} sm={6}>
            <NumberInput
              isForm
              fullWidth
              numberType="integer"
              name="codigoNovoComercial"
              label={LABEL_NOVO_CODIGO_COMERCIAL}
              value={codigoNovoComercial}
              onChange={handleChangeCodigoNovoComercial}
              acceptEmptyValue
            />
          </Grid24>
          <Grid24 xs={24} sm={3}>
            <ButtonUI
              className={style.searchButtonText}
              disabled={codigoNovoComercial.trim() === ''}
              showLoading={loadingComercialNovo}
              onClick={handleConsultarNovoComercial}
            >
              {LABEL_CONSULTAR}
            </ButtonUI>
          </Grid24>
        </Grid24>
      )}

      {comercialNovo && (
        <>
          <Grid24 container isFormContainer spacing="1" className={style.formSection}>
            <Grid24 xs={24} sm={10}>
              <InputField
                disabled
                isForm
                fullWidth
                label={LABEL_NOME_COMERCIAL}
                value={comercialNovo.nome ?? ''}
              />
            </Grid24>
          </Grid24>

          <Grid24 container isFormContainer spacing="1" className={style.formSection}>
            <Grid24 xs={24} sm={14}>
              <TextareaField
                isForm
                fullWidth
                label={LABEL_JUSTIFICATIVA}
                name="justificativa"
                value={justificativa}
                onChange={handleChangeJustificativa}
                showCounter
                maxCounter={MAX_COUNTER_JUSTIFICATIVA}
              />
            </Grid24>
          </Grid24>

          <Grid24 container isFormContainer spacing="1" className={style.formSection}>
            <Grid24 xs={24} sm={4}>
              <ButtonUI
                color="success"
                onClick={abrirConfirmacao}
                disabled={!habilitarBotaoAlterar}
              >
                {LABEL_ALTERAR}
              </ButtonUI>
            </Grid24>
          </Grid24>
        </>
      )}

      <OptionDialogNew
        open={confirmacaoAberta}
        onClickCancel={fecharConfirmacao}
        onClickConfirm={confirmarAlteracao}
        confirmLabel="Confirmar"
        cancelLabel="Cancelar"
      >
        <p>{MENSAGEM_CONFIRMACAO_ALTERACAO}</p>
      </OptionDialogNew>
    </WrapperSubTitleForm>
  );
}
